export const deviationCategory = [
  {
    value: "1",
    label:
      "Plan was approved and deviation beyond permissible limit Upto extent of 10%",
  },
  {
    value: "2",
    label:
      "Plan was not approved and construction carried out without deviation",
  },
  {
    value: "3",
    label:
      "Plan was not approved and deviation beyond permissible limit Upto the extent of 10%",
  },
  {
    value: "4",
    label:
      "Building constructed on under size plot to the extent of 10% less than the permissible plot size",
  },
];

export const nameSuffix = [
  {
    value: "Mr.",
    label: "Mr.",
  },
  {
    value: "Mrs.",
    label: "Mrs.",
  },
  {
    value: "Miss",
    label: "Miss",
  },
];

export const relationSuffix = [
  {
    value: "S/O",
    label: "S/O",
  },
  {
    value: "D/O",
    label: "D/O",
  },
  {
    value: "W/O",
    label: "W/O",
  },
];

export const propertyType = [
  {
    value: "Govt.",
    label: "Govt.",
  },
  {
    value: "Private",
    label: "Private",
  },
  {
    value: "other",
    label: "Other",
  },
];
export const yesOrNo = [
  {
    value: "yes",
    label: "Yes",
  },
  {
    value: "no",
    label: "No",
  },
];

export const genderData = [
  {
    value: "male",
    label: "Male",
  },
  {
    value: "female",
    label: "Female",
  },
  {
    value: "other",
    label: "Other",
  },
];
export const appealApplicationStatus = [
  {
    value: "Individual",
    label: "Individual",
  },
  {
    value: "Firm",
    label: "Firm",
  },
  {
    value: "Company",
    label: "Company",
  },
  {
    value: "AssociationOfPerson",
    label: "Association of Person",
  },
  {
    value: "Co-operativeSociety",
    label: "Co-operative Society",
  },
  {
    value: "Other",
    label: "Other",
  },
];
export const existingLandUse = [
  {
    value: "Commercial",
    label: "Commercial",
  },
  {
    value: "Industrial",
    label: "Industrial",
  },
  {
    value: "Residential",
    label: "Residential",
  },
  {
    value: "Agriculture",
    label: "Agriculture",
  },
  {
    value: "PublicSemipublic",
    label: "Public Semi public",
  },
];
export const typeOfLandForDevelopment = [
  {
    value: "Commercial",
    label: "Commercial",
  },
  {
    value: "Industrial",
    label: "Industrial",
  },
  {
    value: "Residential",
    label: "Residential",
  },

  {
    value: "PublicSemipublic",
    label: "Public Semi public",
  },
];

export const typeOfCluInvolved = [
  {
    value: "For change of Land use from the original Use",
    label: "For change of Land use from the original Use",
  },
  {
    value: "IDP/Develop-ment plan to other Use",
    label: "IDP/Develop-ment plan to other Use",
  },
  {
    value: "Plot No./Khasra No.",
    label: "Plot No./Khasra No.",
  },
  {
    value: " Plot Area",
    label: " Plot Area",
  },
];

export const natureOfTower = [
  {
    value: "Unauthorised",
    label: "Unauthorised",
  },
  {
    value: "New Installation ",
    label: "New Installation ",
  },
];

export const towerToBeProposed = [
  {
    value: "OnGround",
    label: "On Ground",
  },
  {
    value: "At Roof top ",
    label: "At Roof top ",
  },
];

export const DistrictsData=[
  { 
    value:"Bilaspur",
    label:"Bilaspur"
  },
  {
      value:"Chamba",
      label:"Chamba"
  },
  {
    value:"Hamirpur",
    label:"Hamirpur"
},
{
  value:"Kangra",
  label:"Kangra"
},
{
  value:"Kinnaur",
  label:"Kinnaur"
},
{
  value:"Lahaul and Spiti",
  label:"Lahaul and Spiti"
},
{
  value:"Mandi",
  label:"Mandi"
},
{
  value:"Shimla",
  label:"Shimla"
},
{
  value:"Sirmaur",
  label:"Sirmaur"
}
];

export const NamesOFULB=[
  {
    value:"Corp",
    label:"Corp"
  },
  {
    value:"Council",
    label:"Council"
  },
  {
    value:"NP",
    label:"NP"
  }
]

export const statesData=[
  {
    value:"Andaman and Nicobar" ,
    label:"Andaman and Nicobar"
   },
  {
    value:"Andhra Pradesh",
    label:"Andhra Pradesh"

  },
  {
    value:"Arunachal Pradesh",
    label:"Arunachal Pradesh"

  },
  {
    value:"Assam",
    label:"Assam"

  },
  {
    value:"Bihar",
    label:"Bihar"

  },
  {
    value:"Chandigarh",
    label:"Chandigarh"

  },
  {
    value:"Chhattisgarh",
    label:"Chhattisgarh"

  },

]

export const PaymentHeads=[
  {
    value:"Payment Summary" ,
    label:"Payment Summary"
   },
  {
    value:"Processing Fee",
    label:"Processing Fee"

  },
  {
    value:"e-charge (2.00)%",
    label:"e-charge (2.00)%"

  },
  {
    value:"Muck Charges",
    label:"Muck Charges"

  },
{
    value:"Total Payment Amount",
    label:"Total Payment Amount"

  },  

  {
    value:"All",
    label:"All"

  },  

]
export const NotifiedArea=[
  {
    value:"Hatkoti",
    label:"Hatkoti"
  },
  {
    value:"Sarahan",
    label:"Sarahan"
  },
  {
    value:"Shoghi",
    label:"Shoghi"
  },
  {
    value:"Kufri",
    label:"Kufri"
  },
  {
    value:"Barog",
    label:"Barog"
  },
  {
    value:"Harat",
    label:"Harat"
  }
]
export const VillagesData=[
  { 
    value:"Nako",
    label:"Nako"
  },
  {
      value:"Kardang",
      label:"Kardang"
  },
  {
    value:"Chitkul",
    label:"Chitkul"
},
{
  value:"Kibber",
  label:"KIbber"
},
{
  value:"Komic",
  label:"KOmic"
},
{
  value:"Langza",
  label:"Langza"
},
{
  value:"Dhankar",
  label:"Dhankar"
},
{
  value:"Barot",
  label:"Barot"
},
{
  value:"Malana",
  label:"Malana"
}
];
export const WardData=[
  { 
    value:"Bharari",
    label:"Bharari"
  },
  {
      value:"Kaithu",
      label:"Kaithu"
  },
  {
    value:"Annadale",
    label:"Annadale"
},
{
  value:"Majhat",
  label:"Majhat"
},
{
  value:"Nabha",
  label:"Nabha"
},
{
  value:"Fagli",
  label:"Fagli"
},
{
  value:"Jakhu",
  label:"Jakhu"
},
{
  value:"Benmore",
  label:"Benmore"
},
{
  value:"Malyana",
  label:"Malyana"
}
];
export const TehsilData=[
  { 
    value:"Jawali",
    label:"Jawali"
  },
  {
      value:"Indora",
      label:"Indora"
  },
  {
    value:"Dehra",
    label:"Dehra"
},
{
  value:"Shahpur",
  label:"Shahpur"
},
{
  value:"Baroh",
  label:"Baroh"
},
{
  value:"Khundian",
  label:"Khundian"
},
{
  value:"Dadasiba",
  label:"Dadasiba"
},
{
  value:"Rakkar",
  label:"Rakkar"
},
{
  value:"Fatehpur",
  label:"Fatehpur"
}
];